const translations = {
  "pagination.results": "{from}-{to} of {total} results",

  "reminders.card-link.title": "Activate Rewards & More!",
  "reminders.card-link.subtitle": "Unlock the full perks and benefits. Subscribe Now.",

  "reminders.sweepstakes.title": "You're enrolled in our monthly giveaway",
  "reminders.sweepstakes.subtitle": "See my numbers",
}

export default translations;